module.exports = __webpack_public_path__ + "static/img/banner_ar.72a8fb27.png";